import { render, staticRenderFns } from "./OrderRequestTab.vue?vue&type=template&id=27239412&scoped=true"
import script from "./OrderRequestTab.vue?vue&type=script&lang=js"
export * from "./OrderRequestTab.vue?vue&type=script&lang=js"
import style0 from "./OrderRequestTab.vue?vue&type=style&index=0&id=27239412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27239412",
  null
  
)

export default component.exports